import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { authActions } from "../../store/auth";
import { grnActions } from "../../store/grn";
import { useNavigate, useLocation } from "react-router-dom";
import LogoIcon from "../../assets/images/logo.png";
import userIcon from "../../assets/icons/user.svg";
import CommonModal from "../../containers/common_modal";
import ErrorModal from "../../containers/error_modal";
import "./header.css";
import { logoutSSO } from "../../utils/ssoHelper";
import { init, ChatButton } from "more-desk-one";
import { APP_NAME, CSA_HELP_API_KEY, CSA_HELP_URL, IDP_URL } from "../../constants/constants";
import { ENV } from "more-sso-sdk";
const Header = ({ ...props }) => {
  const {
    clearAuth,
    user,
    clearGrnData,
    widthIsSmall,
    token,
    lambdaErr,
    updateLambdaErr,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const invokeReloginModal = useRef();
  const closeReloginModal = useRef();
  const errorOpenErrRef = useRef();
  const errorCloseErrRef = useRef();
  const redirectURL = encodeURIComponent(window.location.origin);
  const isDev = process.env.REACT_APP_ENV === "DEV";
  const onLogout = async () => {
    clearAuth();
    clearGrnData();
    await logoutSSO();
    return;

  };

  useEffect(() => {
    if (!token) {
      invokeReloginModal.current?.click();
    }
  }, [token]);


  useEffect(() => {
    if (!token) return;
    init(
      {
        apiURL: CSA_HELP_URL,
        apiKey: CSA_HELP_API_KEY,
        accessToken: token,
        env: isDev ? ENV.DEV : ENV.PROD,
        redirectUrl: redirectURL,
        app: APP_NAME,
        idp: IDP_URL
      });
  }, [token]);

  useEffect(() => {
    if (lambdaErr) {
      errorOpenErrRef.current?.click();
    }
  }, [lambdaErr]);

  const Relogin = () => (
    <div className="d-flex flex-column mt-4 mx-3 mb-2">
      <div className="add-item-head">Please login again</div>
      <div className="d-flex flex-column">
        <div className="submit-add-text">
          Your session has expired. Please press Relogin to continue.
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-preview mt-5"
          onClick={() => {
            closeReloginModal.current?.click();
            onLogout();
          }}
        >
          Relogin
        </button>
      </div>
    </div>
  );

  const roleText = user?.role ? String(user.role) : "";
  const locText =
    user?.loc != null && user?.loc !== ""
      ? String(user.loc)
      : "";

  const locNameText =
    user?.locationName && String(user.locationName).trim()
      ? String(user.locationName).trim()
      : "";

  const roleLine = (() => {
    if (!roleText) return "";
    if (!locText && !locNameText) return roleText;

    if (locText && locNameText) return `${roleText} - ${locText} (${locNameText})`;
    if (locText) return `${roleText} - ${locText}`;
    return `${roleText} (${locNameText})`;
  })();

  return (
    <>
      <div
        className="d-flex justify-content-between hd align-items-center"
        style={{
          padding: widthIsSmall ? "10px 0px 10px 12px" : "12px 26px 12px 60px",
        }}
      >
        {/* <div
          style={{

            position: 'absolute',
            bottom: 30,
            zIndex: 9999,
            right: 30,
            border: '1px solid #000',
            borderRadius: 15,
          }}
        >
          <ChatButton align="end" side="right" />
        </div> */}


        <img
          className="head-icon"
          src={LogoIcon}
          alt="img"
          onClick={() => navigate("/home")}
        />

        <div className="d-flex align-items-center gap-3">

          <div
            className={[
              "hd-detail d-flex flex-column justify-content-end text-end",
              widthIsSmall && "mr-sm",
            ].join(" ")}
          >
            <div className="hd-user text-capitalize">
              {(user?.name && `${user.name}`) || ""}
            </div>
            {roleLine ? (
              <div className="hd-role text-capitalize">{roleLine}</div>
            ) : null}
          </div>
          <div className="dropdown">
            <div
              className="dropdown-toggle"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={userIcon} alt="user" className="user-icon" />
            </div>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                className="ps-3"
                onClick={() =>
                  navigate(
                    location.pathname === "/profile" ? "/home" : "/profile"
                  )
                }
              >
                {location.pathname !== "/profile" ? "Switch Profile" : "Home"}
              </li>
              <li className="ps-3" onClick={onLogout}>
                Logout
              </li>
            </ul>
          </div>
        </div>
      </div>
      <CommonModal
        id={"reloginModal"}
        content={<Relogin />}
        modalOpenRef={invokeReloginModal}
        modalCloseRef={closeReloginModal}
      />
      <ErrorModal
        id={"errorCommonModal"}
        openRef={errorOpenErrRef}
        closeRef={errorCloseErrRef}
        headerColor={"red"}
        msg={"Something went wrong"}
        closeModal={() => updateLambdaErr(false)}
        backDrop={true}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  widthIsSmall: state?.auth?.widthIsSmall,
  token: state?.auth?.token,
  lambdaErr: state?.grn?.lambdaErr,
});

const mapDispatchToProps = (dispatch) => ({
  clearAuth: () => dispatch(authActions.clearAuth()), // ✅ better than logout+clearTokenData
  clearGrnData: () => dispatch(grnActions.clearGrnData()),
  updateLambdaErr: (data) => dispatch(grnActions.updateLambdaErr(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);